import {useState} from "react";
import {useNavigate} from "react-router-dom";
import VehicleService from "../services/api";
import {useSnackbar} from "notistack";
import useVehicleStore from "../zustand/useVehicleStore";


const useVehicle = () => {
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();

    const {setVehicleCreated, setVehicleStatusUpdated} = useVehicleStore();

    const [isFetchingVehicleList, setFetchingVehicleList] = useState(false);
    const [vehicleListData, setVehicleListData] = useState([]); 
    const [isAddingVehicle, setAddingVehicle] = useState(false);
    const [isFetchingVehicleType, setFetchingVehicleType] = useState(false);
    const [vehicleTypes, setVehicleTypes] = useState([]);
    const [isViewingVehicle, setViewingVehicle] = useState(false);
    const [vehicleDetails, setVehicleDetails] = useState({});
    const [isFetchingActiveVehicleList, setFetchingActiveVehicleList] = useState(false);
    const [activeVehicleList, setActiveVehicleList] = useState([]);
    const [isUpdatingVehicleStatus, setUpdatingVehicleStatus] = useState(false);
    const [isUpdatingVehicle, setUpdatingVehicle] = useState(false);
    const [isFetchingAccessLogs, setFetchingAccessLogs] = useState(false);
    const [vehicleAccessLogs, setVehicleAccessLogs] = useState([]);
    const [isFilteringVehicle, setFilteringVehicle] = useState(false);


    const listVehicle = (parameters) => {
        setFetchingVehicleList(true);   
        setVehicleCreated(false);
        setVehicleStatusUpdated(false);

        VehicleService.listVehicle(parameters).then((res) => {
            console.log("listVehicle data xxxx", res);

            if (res.data.success) {
                setFetchingVehicleList(false);
                setVehicleListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching vehicle list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setVehicleListData([]);
            setFetchingVehicleList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const createVehicle = (payload, orgIdFromUrlForPortEmployee) => {
        setAddingVehicle(true);

        VehicleService.createVehicle(payload).then((res) => {
            console.log("createVehicle data xxxx", res);

            if (res.data.success) {
                setAddingVehicle(false);
                setVehicleCreated(true);
                enqueueSnackbar("Successfully created vehicle", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                if (orgIdFromUrlForPortEmployee) {
                    navigate(`/organization/view/vehicles/view?org_uid=${res.data.data.data.org_uid}&id=${res.data.data.data.vehicle_uid}`);

                } else {
                    navigate(`/vehicles/view?id=${res.data.data.data.vehicle_uid}`);
                }
            }  

        }).catch((error) => {
            console.error("Error creating vehicle:", error);
            console.log("createVehicle data xxxx", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setAddingVehicle(false);
            setVehicleCreated(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4500
            })
        })   
    }

    const getVehicleTypes = () => {
        setFetchingVehicleType(true);

        VehicleService.getVehicleTypes().then((res) => {
            console.log("getVehicleTypes data xxxx", res);

            if (res.data.success) {
                setFetchingVehicleType(false);
                setVehicleTypes(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching vehicle types:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setVehicleTypes([]);
            setFetchingVehicleType(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getViewVehicle = (parameters) => {
        setViewingVehicle(true);

        VehicleService.getViewVehicle(parameters).then((res) => {
            console.log("getViewVehicle data xxxx", res);

            if (res.data.success) {
                setViewingVehicle(false);
                setVehicleDetails(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching vehicle:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setVehicleDetails([]);
            setViewingVehicle(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getActiveVehicleList = (parameters) => {
        setFetchingActiveVehicleList(true);

        VehicleService.getActiveVehicleList(parameters).then((res) => {
            console.log("getActiveVehicleList data xxxx", res);

            if (res.data.success) {
                setFetchingActiveVehicleList(false);
                setActiveVehicleList(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching active vehicle list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setActiveVehicleList([]);
            setFetchingActiveVehicleList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateVehicleStatus = (parameters) => {
        setUpdatingVehicleStatus(true);

        VehicleService.updateVehicleStatus(parameters).then((res) => {
            console.log("updateVehicleStatus data xxxx", res);

            if (res.data.success) {
                setUpdatingVehicleStatus(false);
                setVehicleStatusUpdated(true);

                enqueueSnackbar("Successfully updated vehicle status", {
                    variant: "success",
                    autoHideDuration: 3500
                })
            } 

        }).catch((error) => {
            console.error("Error updating vehicle status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setVehicleStatusUpdated(false);
            setUpdatingVehicleStatus(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateVehicle = (parameters, payload, orgIdFromUrlForPortEmployee) => {
        setUpdatingVehicle(true);

        VehicleService.updateVehicle(parameters, payload).then((res) => {
            console.log("updateVehicle data xxxx", res);

            if (res.data.success) {
                setUpdatingVehicle(false);
                enqueueSnackbar("Successfully updated vehicle", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                if (orgIdFromUrlForPortEmployee) {
                    navigate(`/organization/view/vehicles/view?org_uid=${res.data.data.org_uid}&id=${res.data.data.vehicle_uid}`);

                } else {
                    navigate(`/vehicles/view?id=${res.data.data.vehicle_uid}`);
                }
            } 

        }).catch((error) => {
            console.error("Error updating vehicle:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingVehicle(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const getVehicleAccessLogs = (parameters) => {
        setFetchingAccessLogs(true);

        VehicleService.getVehicleAccessLogs(parameters).then((res) => {
            console.log("getVehicleAccessLogs data xxxx", res);

            if (res.data.success) {
                setFetchingAccessLogs(false);
                setVehicleAccessLogs(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching vehicle access logs:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setVehicleAccessLogs([]);
            setFetchingAccessLogs(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const filterVehicle = (parameters) => {
        setFilteringVehicle(true);

        VehicleService.filterVehicle(parameters).then((res) => {
            console.log("filterVehicle data xxxx", res);
    
            if (res.data.success) {
                setFilteringVehicle(false);
                setVehicleListData(res.data.data);
            } 
    
        }).catch((error) => {
            console.error("Error filtering vehicle list:", error);
            const errorMessage = error?.response?.data?.error || error.message;
    
            setVehicleListData(null);
            setFilteringVehicle(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }


    return {
        isFetchingVehicleList,
        vehicleListData,
        listVehicle,

        isAddingVehicle,
        createVehicle,

        isFetchingVehicleType,
        vehicleTypes,
        getVehicleTypes,

        isViewingVehicle,
        vehicleDetails,
        getViewVehicle,

        activeVehicleList,
        isFetchingActiveVehicleList,
        getActiveVehicleList,

        isUpdatingVehicleStatus,
        updateVehicleStatus,

        isUpdatingVehicle,
        updateVehicle,

        isFetchingAccessLogs, 
        vehicleAccessLogs,
        getVehicleAccessLogs,

        isFilteringVehicle,
        filterVehicle,
    }
}

export default useVehicle